import { useTranslation } from "react-i18next";

import { Icon } from "@atoms";

// An area that takes no bookings, only people who walk in
export const AreaAdHocUse = () => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center gap-4 text-mapiq-black-400">
      <Icon
        icon="noCalendar"
        size="24px"
        color="currentColor"
      />
      <h4 className="text-[15px] font-semibold leading-5 text-mapiq-black-800*">{t("hereAndNow:AdHocUse")}</h4>
    </div>
  );
};
